// removed by extract-text-webpack-plugin
module.exports = {"root":"Toolbox__root___kY-W8","title":"Toolbox__title___34LbS","row":"Toolbox__row___3fIKL","colorPicker":"Toolbox__colorPicker___11IKv","label":"Toolbox__label___1fhEV","fontSize":"Toolbox__fontSize___1owg8","fontStyle":"Toolbox__fontStyle___1WfeP","fontStylePickerItem":"Toolbox__fontStylePickerItem___2NmAw","fontStylePickerItemActive":"Toolbox__fontStylePickerItemActive___1joJ5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Textarea/Toolbox/Toolbox.scss
// module id = 994
// module chunks = 0